import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ContentLayout from '@/layouts/content-layout'
import ArticleFormView from '@/sections/articles/view/article-form-view'

export default function ArticleFormPage() {
  const location = useLocation()

  // Determine title based on pathname
  const title = useMemo(() => {
    if (location.pathname.includes('/articles/create')) {
      return 'เพิ่ม RFC Talk'
    }
    if (location.pathname.match(/^\/articles\/[^/]+\/edit/)) {
      return 'แก้ไข RFC Talk'
    }
    return 'RFC Talk'
  }, [location.pathname])

  return (
    <ContentLayout title={title} backButton>
      <ArticleFormView />
    </ContentLayout>
  )
}
